import { Component, Input, HostBinding, OnInit } from '@angular/core';
import { GeneralService } from 'src/app/shared/services/general.service';
import { AdDefaults } from '../ad-default';


@Component({
    selector: 'learning',
    templateUrl: './learning.component.html',
    styleUrls: ['./learning.component.scss']
})
export class LearningComponent extends AdDefaults implements OnInit {


    @Input() info : any;
    @Input() template : any = 'top';
    @Input() images : any = null;
    @HostBinding('className') className = '';

    viewInit = false;

    _images : any = [];

    swiperConfig : any = {
        init:true,
        direction: 'horizontal',
        observer: true,
        observeParents: true,
        slidesPerView: 1,
        pagination: {
            modifierClass: 'container style2-pagination-',
            el: '.swiper-pagination',
            type: 'fraction',
            renderFraction: function (currentClass, totalClass) {
                return '<span class="' + currentClass + '"></span>' +
                ' / ' +
                '<span class="' + totalClass + '"></span>';
            },
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    };

    constructor( 
        protected gs : GeneralService
    ){
        super(gs);
    }


    ngOnInit(){
        this.className = 'template-'+this.template;
        this._images = this.images || this.info.imagesHighlight;
        super.ngOnInit();
    }

}